import React from 'react';
import melek from "../assets/melek.png";
import aziz from "../assets/aziz.png";
import zeki from "../assets/zeki.png";
import ceren from "../assets/ceren.png";
import onur from "../assets/onur.png";

function BizKimiz(props) {
    return ( <section
            className="team-and-counter py-120 bg-img"
            style={{backgroundImage: "url(./assets/images/thumb/team-bg.png)", backgroundColor: "#0a0a0a"}}
        >
            <div className="team-bottom-thumb">
                <img src="assets/images/thumb/footer-bid.png" alt=""/>
            </div>
            {/* Team Start */}
            <div className="team-wrapper">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-12">
                            <div className="section-heading style-two">
                                <h5 className="section-heading__subtitle" style={{color: "#fff"}}>
                                    <span className="section-heading__bars bars-one"/> EKİP{" "}
                                    <span className="section-heading__bars bars-two"/>
                                </h5>
                                <h2 className="section-heading__title" style={{color: "white"}}>
                                    {" "}
                                    <span className="section-heading__title-colored">
                 AUDIOTIME
                </span>{" "} AİLESİ
                                </h2>

                            </div>
                        </div>
                    </div>
                    <div
                        className="row team-item-wrapper dots-right-top margin-in-slider justify-content-center gy-4">
                        <div className="team-item">
                            <div className="team-item__thumb">
                                <img src={melek} alt=""/>
                                <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Melek Doyan Etik
                                        </span>{" "}
                                    <span className="team-item__title-colored">Managing Partner</span>{" "}
                                </h4>
                            </div>
                        </div>
                        <div className="team-item">
                            <div className="team-item__thumb">
                                <img src={zeki} alt=""/>
                                <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Zeki Gültekin
                                        </span>{" "}
                                    <span className="team-item__title-colored">Managing Partner</span>{" "}
                                </h4>
                            </div>
                        </div>
                        <div className="team-item">
                            <div className="team-item__thumb">
                                <img src={ceren} alt=""/>
                                <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Ceren Dinlergüler
                                        </span>{" "}
                                    <span className="team-item__title-colored">Advertising Sales Manager</span>{" "}
                                </h4>
                            </div>
                        </div>
                        <div className="team-item">
                            <div className="team-item__thumb">
                                <img src={onur} alt=""/>
                                <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Onur Kavran
                                        </span>{" "}
                                    <span className="team-item__title-colored">Reservation Manager</span>{" "}
                                </h4>
                            </div>
                        </div>
                        <div className="team-item">
                            <div className="team-item__thumb">
                                <img src={aziz} alt=""/>
                                <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Aziz Şişman
                                        </span>{" "}
                                    <span className="team-item__title-colored">Operations Specialist</span>{" "}
                                </h4>
                            </div>
                        </div>
                        {/*<div className="team-item">*/}
                        {/*    <div className="team-item__thumb">*/}
                        {/*        <img src="assets/images/thumb/team-img-02.png" alt="" />*/}
                        {/*        <div className="team-item__socails">*/}
                        {/*            <ul className="social-list">*/}
                        {/*                <li className="social-list__item">*/}
                        {/*                    <a*/}
                        {/*                        href="https://www.facebook.com"*/}
                        {/*                        className="social-list__link"*/}
                        {/*                    >*/}
                        {/*                        <span className="icon-facebook" />*/}
                        {/*                    </a>{" "}*/}
                        {/*                </li>*/}
                        {/*                <li className="social-list__item">*/}
                        {/*                    <a*/}
                        {/*                        href="https://www.twitter.com"*/}
                        {/*                        className="social-list__link active"*/}
                        {/*                    >*/}
                        {/*                        {" "}*/}
                        {/*                        <span className="icon-twitter" />*/}
                        {/*                    </a>*/}
                        {/*                </li>*/}
                        {/*                <li className="social-list__item">*/}
                        {/*                    <a*/}
                        {/*                        href="https://www.linkedin.com"*/}
                        {/*                        className="social-list__link"*/}
                        {/*                    >*/}
                        {/*                        {" "}*/}
                        {/*                        <span className="icon-linkedin" />*/}
                        {/*                    </a>*/}
                        {/*                </li>*/}
                        {/*                <li className="social-list__item">*/}
                        {/*                    <a*/}
                        {/*                        href="https://www.pinterest.com"*/}
                        {/*                        className="social-list__link"*/}
                        {/*                    >*/}
                        {/*                        {" "}*/}
                        {/*                        <span className="icon-pinterest" />*/}
                        {/*                    </a>*/}
                        {/*                </li>*/}
                        {/*            </ul>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}


                    </div>
                </div>
            </div>
            {/* team End */}
        </section>
    );
}

export default BizKimiz;